import { render } from "./CadastrarDepoimento.vue?vue&type=template&id=2d39fa8e&scoped=true"
import script from "./CadastrarDepoimento.vue?vue&type=script&lang=js"
export * from "./CadastrarDepoimento.vue?vue&type=script&lang=js"

import "./CadastrarDepoimento.vue?vue&type=style&index=0&id=2d39fa8e&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d39fa8e"]])

export default __exports__